<div class="modal-container  popup-general modal-md percent_5 top_100_negative">
    <div class="modal-container-header ">
        <span>{{ 'gestion_terceros.identificationData.searchArcad' | translate}}</span>
        <span class="k-icon k-i-close" (click)="closeModal('cerrar')"></span>
    </div>

    <form class="text-size-small" [formGroup]="_tablaSearchService.formInvoices">
        <div class="modal-container-section col-12">

            <div class="row mb-2">
                <div class="col-12 form-group">

                    <div class="k-input informes ">
                        <label>{{'gestion_terceros.identificationData.arcadCode' | translate}}:</label>
                        <input type="text" (focus)="search('searchCustomerCode')"
                            (blur)="cancelSearch('searchCustomerCode')" formControlName="searchCustomerCode"
                            class="form-control mr-1">
                        <span><i class="k-icon k-i-search"></i></span>
                    </div>

                    <div class="k-input informes mt-1">
                        <label>{{'labels.name' | translate}}</label>
                        <input type="text" (focus)="search('searchCustomerName')"
                            (blur)="cancelSearch('searchCustomerName')" formControlName="searchCustomerName"
                            class="form-control mr-1">
                        <span><i class="k-icon k-i-search"></i></span>
                    </div>

                </div>
            </div>

            <app-tabla-search (anadido)="anadido($event)">
            </app-tabla-search>

            <div class="modal-footer p-0">
                <button type="button" [disabled]="!_tablaSearchService.filaAnadida"
                    class="btn btn-secondary  verde_con_efecto border_all" (click)="closeModal('anadir')">
                    <span class="k-icon k-i-check-circle text-size-big"></span>
                    {{ 'labels.anadir' | translate}}
                </button>
            </div>


        </div>
    </form>
</div>
